module.exports = __webpack_public_path__ + "static/media/juanpablo.110fcb69.png";